import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { store } from "../../../../Store";

/**
 * Renderiza el menú desplegable de planes disponible en la navegación pública.
 *
 * El componente muestra enlaces a los diferentes tipos de planes ofrecidos
 * por la plataforma (bibliotecas, colegios y casa). La disponibilidad de
 * algunos enlaces puede variar según el país configurado en el estado global.
 *
 * @param {Object} props - Propiedades del componente.
 * @param {Object} props.textosInterfaz - Textos utilizados para las etiquetas del menú.
 * @param {Object} props.showADropdown - Controlador de visibilidad del menú principal.
 * @param {boolean} props.visibleDropdown - Indica si el menú principal se encuentra visible.
 *
 * @returns {JSX.Element} PlansDropdownPublic
 */
export const PlansDropdownPublic = ({ textosInterfaz, showADropdown, visibleDropdown }) => {
    const globalState = useContext(store);
    const { state } = globalState;
    const country = state?.pais?.toLowerCase();
    const [showPlans, setShowPlans] = useState(false);

    return (
        <li className={`plans-dropdown-public ${visibleDropdown ? 'activeMode' : 'inactiveMode'}`}>

            <button 
                className={`btn-plans focusable-red`}
                onClick={()=> setShowPlans(!showPlans)}
                style={{
                    padding: showPlans ? 15 : 0, 
                    fontWeight:700
                }}
            >
                {textosInterfaz?.quiero_make || 'Planes'}
            </button>

            <ul className={`subDrop-plans ${showPlans ? 'activeMode' : 'inactiveMode'}`}>
                <li>
                    <Link
                        role="menuitem"
                        to="/que-es/bibliotecas"
                        style={{ fontWeight: 500 }}
                        className="link-secundario d-flex justify-content-center align-items-center focusable-red "
                        onClick={() => showADropdown.setVisible(false)}
                    >{textosInterfaz?.plan_bibliotecas || 'Plan bibliotecas'}</Link>
                </li>
                <li className={`${visibleDropdown ? 'activeMode' : 'inactiveMode'}`} >
                    <Link
                        role="menuitem"
                        to="/que-es/colegios"
                        className="link-secundario d-flex justify-content-center align-items-center focusable-red"
                        style={{ fontWeight: 500 }}
                        onClick={() => showADropdown.setVisible(false)}
                    >
                        {textosInterfaz?.plan_colegios || 'Plan colegios'}
                    </Link>
                </li>

                {
                    country !== 'us' &&
                    <li className={`${visibleDropdown ? 'activeMode' : 'inactiveMode'}`} style={{ fontWeight: 500 }}>
                        <Link
                            role="menuitem"
                            to="/tienda/plan-casa"
                            className="link-secundario d-flex justify-content-center align-items-center focusable-red"
                            onClick={() => showADropdown.setVisible(false)}
                        >{textosInterfaz?.plan_casa || 'Plan casa'}</Link>
                    </li>
                }
            </ul>
        </li>
    )
}